// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  refresh_token: null,
  access_token: null,
  user: JSON.parse(window.localStorage.getItem('user')),
  company: JSON.parse(window.localStorage.getItem('company')),
  authenticationStatus: window.localStorage.getItem('authenticationStatus'),
}

export const mutations = {
  SET_REFRESH_TOKEN(state, refresh_token) {
    state.refresh_token = refresh_token
    window.localStorage.setItem('refresh_token', refresh_token)
  },
  SET_ACCESS_TOKEN(state, access_token) {
    state.access_token = access_token
    window.localStorage.setItem('access_token', access_token)
  },
  SET_USER(state, user) {
    state.user = user
    window.localStorage.setItem('user', JSON.stringify(user))
  },
  SET_COMPANY(state, company) {
    state.company = company
    window.localStorage.setItem('company', JSON.stringify(company))
  },
  SET_AUTHENTICATION_STATUS(state, authenticationStatus) {
    state.authenticationStatus = authenticationStatus
    window.localStorage.setItem('authenticationStatus', authenticationStatus)
  },
  CLEAR_AUTH_DATA() {
    // window.localStorage.clear()
    window.localStorage.removeItem('refresh_token')
    window.localStorage.removeItem('access_token')
    window.localStorage.removeItem('user')
    window.localStorage.removeItem('company')
    window.localStorage.removeItem('authenticationStatus')
  },
}

export const actions = {
  logout({ commit }) {
    commit('CLEAR_AUTH_DATA')
    return Promise.resolve()
  },
  changePassword({ commit }, payload) {
    return ApiService.changePassword(payload)
      .then(() => {})
      .catch((error) => {
        throw error
      })
  },
  me({ commit }) {
    return ApiService.me()
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchUiConfig({ commit }, company_uuid) {
    return ApiService.fetchUiConfig(company_uuid)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchMyPolicies({ commit }, payload) {
    return ApiService.fetchMyPolicies(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
}
